export function formatQuillToSMS(html) {
  if (!html) return '';

  return html
    // Convert paragraph and line breaks
    .replace(/<p><br><\/p>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<p>/gi, '')

    // Remove non-breaking spaces
    .replace(/&nbsp;/gi, ' ')

    // Remove remaining HTML tags
    .replace(/<[^>]+>/g, '')

    // Decode common entities
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')

    // Normalize whitespace
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
